import { ZERO_FIAT_AMOUNT } from "@hsbc/shared";
import { walletApi } from "./api";

export const defaultBalance = ZERO_FIAT_AMOUNT;

export const walletReducers = {
  [walletApi.reducerPath]: walletApi.reducer,
};

export const walletMiddleware = [walletApi.middleware];
